<template>
  <div>
    <form class="blueprint-release pad-below">
      <fieldset class="form-entry">
        <label for="blueprint-release-input"><i class="fas fa-thumbtack" aria-hidden="true"></i>Release on:</label>
        <k-numeric-input
          v-model="releaseOnDay"
          input-id="blueprint-release-input"
          :min="1"
          :step="1"
          :precision="0"
          input-placeholder="(day)"
        />
      </fieldset>
      <fieldset class="form-entry">
        <label for="blueprint-completion-input"><i class="fas fa-check" aria-hidden="true"></i>Duration:</label>
        <k-numeric-input
          v-model="expectedCompletionDays"
          input-id="blueprint-completion-input"
          :min="1"
          :step="1"
          :precision="0"
          input-placeholder="(days)"
        />
      </fieldset>
    </form>
    <badge-editor
      :badgeOptions="badgeOptions"
      :badgesSortedByThreshold="badgesSortedByThreshold"
      @remove="onRemoveBadge"
      @onAddBadge="onAddBadge"
    />
  </div>
</template>
<style scoped>
form.blueprint-release {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 1em;
}

form.blueprint-release fieldset {
  max-width: 50%;
}

form.blueprint-release fieldset i.fa-thumbtack {
  color: var(--kate-lu);
}

form.blueprint-release fieldset i.fa-check {
  color: var(--kate-success);
}

form.blueprint-release fieldset i {
  margin-right: 8px;
}

form.blueprint-release :deep(.k-numeric-input) {
  margin-bottom: 0;
  min-width: 14em;
}

form.blueprint-release :deep(p.validation-message) {
  top: 100%;
  bottom: auto;
  left: 0;
  margin-top: 0.25em;
  white-space: nowrap;
}

@media (min-width: 1000px) {
  form.blueprint-release fieldset.form-entry {
    max-width: none;
    flex: 0 1 auto;
  }

  form.blueprint-release :deep(.k-numeric-input) {
    width: 18em;
    max-width: 18em;
  }

  form.blueprint-release :deep(p.validation-message) {
    width: 100%;
    max-width: 100%;
    white-space: normal;
  }
}

.fieldset {
  display: inherit;
}

.pad-below {
  padding-bottom: 2em;
}

.add-badges {
  margin-bottom: 10px;
}

.badges {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
  align-items: center;
}
</style>
<script>

import KNumericInput from '@base-components/k-numeric-input.vue';
import useReleaseModuleStore from '@stores/release-module-store';
import { sortObjectArray } from '@utils/sort-by-object-property';
import BadgeEditor from './badge-editor.vue';

export default {
  components: {
    BadgeEditor,
    KNumericInput,
  },

  props: {
    module: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      releaseModuleStore: useReleaseModuleStore(),
    };
  },

  computed: {
    releaseOnDay: {
      get() {
        const releaseAfterDays = this.releaseModuleStore.getModuleValue(this.module.index, 'release_after_days');
        if (releaseAfterDays == null) {
          return null;
        }
        return releaseAfterDays + 1;
      },
      set(newVal) {
        this.releaseModuleStore.updateModuleProperty(
          this.module.index,
          'release_after_days',
          this.normalizeReleaseOnDayValue(newVal),
        );
      },
    },
    expectedCompletionDays: {
      get() {
        return this.releaseModuleStore.getModuleValue(this.module.index, 'expected_completion_days');
      },
      set(newVal) {
        this.releaseModuleStore.updateModuleProperty(
          this.module.index,
          'expected_completion_days',
          this.normalizeDaysValue(newVal),
        );
      },
    },
    badgeOptions() {
      // isaddedmodule then take active ones
      return this.module.programmeBlueprintBadges?.filter(badge => !this.releaseModuleStore.getModuleProperty(this.module.index, 'badges_in_module')?.map(eb => eb.id).includes(badge.id)) || [];
    },
    badgesSortedByThreshold() {
      return sortObjectArray(this.releaseModuleStore.getModuleProperty(this.module.index, 'badges_in_module') ?? this.module?.badges_in_module);
    },
  },

  methods: {
    normalizeDaysValue(value) {
      if (value === '' || value === null || value === undefined) {
        return null;
      }

      const numericValue = Number(value);
      return Number.isNaN(numericValue) ? null : numericValue;
    },
    normalizeReleaseOnDayValue(value) {
      const normalizedValue = this.normalizeDaysValue(value);
      if (normalizedValue == null) {
        return null;
      }
      return normalizedValue - 1;
    },
    onAddBadge(badge) {
      this.releaseModuleStore.addBadgeToModule(this.module.index, badge);
    },
    onRemoveBadge(badgeId) {
      this.releaseModuleStore.removeBadgeFromModule(this.module.index, badgeId);
    },
  },
};
</script>
